import { Input } from '@chakra-ui/react'
import { FC, useState } from 'react'

import useMrpPurchase from '@hook/mrp/use-purchase'

import LayoutToolsButton from '../../Components/Button'

const ActionMrpPurchaseUpload: FC = () => {
  const [isLoading, setLoading] = useState(false)
  const { postUpload } = useMrpPurchase()

  const handleClick = () => {
    const inputValue =
      document.querySelector<HTMLInputElement>('#purchase-upload')

    inputValue.value = ''
    inputValue!.click()
  }

  return (
    <>
      <LayoutToolsButton
        label="Upload de arquivo"
        isLoading={isLoading}
        loadingText="Fazendo upload"
        onClick={handleClick}
      />
      <Input
        id="purchase-upload"
        d="none"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        onChange={event => {
          postUpload(event)
          setLoading(true)

          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
      />
    </>
  )
}

export default ActionMrpPurchaseUpload
